<app-student-manual-ru *ngIf="language === 'ru'"></app-student-manual-ru>
<app-student-manual-en *ngIf="language === 'en'"></app-student-manual-en>
